import { Collapse } from 'antd';

import styled from 'styled-components';

export const StyledDrawerCollapse = styled(Collapse)`
  &.ant-collapse {
    margin-top: -12px;
    padding-bottom: 12px;
    box-shadow: none;
    > .ant-collapse-item {
      > .ant-collapse-header {
        padding-left: 0;
        padding-right: 0;
        font-weight: 600;
      }
      > .ant-collapse-content > .ant-collapse-content-box {
        padding-left: 0;
        padding-right: 0;
      }
    }
  }
`;
